import React, { useEffect, useState } from 'react';
import { Card, Statistic, Row, Col, message } from 'antd';
import "../../../Assets/Dashboard.css";
import { ReactComponent as VerifiedIcon } from "../../../Assets/images/icon/verifiedIcon.svg";
import apiClient from "../../utilities/apiService";

const Dashboard = () => {
  const [userStats, setUserStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    newSignUps: 0,
    verifiedUsers: 0,
  });

  const [postStats, setPostStats] = useState({
    recipePosts: 0,
    generalPosts: 0,
    importRecipePosts:0

  });

  const [loading, setLoading] = useState(false);

  // Fetch user statistics
  const fetchUserStats = async () => {
    try {
      const response = await apiClient.get(`${process.env.REACT_APP_BACKEND_URL}/admin/dashboard/user`);
      setUserStats(response.data?.data || {});
    } catch (error) {
      message.error(error?.response?.data?.message || 'Failed to fetch user statistics.');
      console.error(error);
    }
  };

  // Fetch post statistics
  const fetchPostStats = async () => {
    try {
      const response = await apiClient.get(`${process.env.REACT_APP_BACKEND_URL}/admin/dashboard/post`);

     
      setPostStats(response?.data?.data || {});
      
    
    } catch (error) {
      message.error( error?.response?.data?.message || 'Failed to fetch post statistics.');
      console.error(error);
    }
  };

  // Fetch all statistics on component mount
  useEffect(() => {
    const fetchAllStats = async () => {
      setLoading(true);
      await Promise.all([fetchUserStats(), fetchPostStats()]);
      setLoading(false);
    };

    fetchAllStats();
  }, []);

  return (
    <div className="dashboard" style={{ flexGrow: 1 }}>
      <Card title="Dashboard" loading={loading}>
        <Row gutter={24} style={{ display: "flex", justifyContent: "space-around" }}>
          <Col span={6}>
            <div className="stat-card">
              <Statistic title="Total Users" value={userStats.totalUsers || 0} />
            </div>
          </Col>
          <Col span={6}>
            <div className="stat-card">
              <Statistic title="Active Users" value={userStats.activeUsers || 0} />
            </div>
          </Col>
          <Col span={6}>
            <div className="stat-card">
              <Statistic title="New Signups" value={userStats.newSignUps || 0} />
            </div>
          </Col>
        </Row>

        <Row gutter={24} style={{ marginTop: '24px', display: "flex", justifyContent: "center" }}>
          <Col span={8}>
            <div className="stat-card">
              <div className="verified-users">
                <VerifiedIcon className="verified-icon" />
                <Statistic title="Verified Users" value={userStats.verifiedUsers || 0} />
              </div>
            </div>
          </Col>
        </Row>

        <Row gutter={24} style={{ marginTop: '24px', display: "flex", justifyContent: "space-around" }} >
          <Col span={6}>
            <div className="stat-card">
              <Statistic title="Recipe Posts" value={postStats.recipePosts || 0} />
            </div>
          </Col>
          <Col span={6}>
            <div className="stat-card">
              <Statistic title="Imported Recipe Posts" value={postStats.importRecipePosts || 0} />
            </div>
          </Col>
          <Col span={6}>
            <div className="stat-card">
              <Statistic title="General Posts" value={postStats.generalPosts || 0} />
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Dashboard;
